import * as Logger from "js-logger";
import Gamestate from "slotworks/model/game-state";
import BuilderManager from "slotworks/server/builders/builder-manager";
import { Connector } from "slotworks/server/connectors/connector";
import Contract from "slotworks/utils/contracts/contract";
class CommsManager {

    public connector: Connector;

    public request(request: any): Contract<void> {
        this.log("Outgoing: ", request);

        const gameplay = Gamestate.getCurrentGame();
        const builtRequest = BuilderManager.buildRequest(gameplay, request);

        return new Contract<void>((resolve) => {
            if (builtRequest) {
                this.connector.sendRequest(builtRequest)
                    .then((response) => {
                        this.response(request, response, resolve);
                    });
            } else {
                this.response(request, {}, resolve);
            }
        });
    }

    public requestRaw(request: any): Contract<void> {
        this.log("Outgoing raw: ", request);

        return new Contract<void>((resolve) => {
            this.connector.sendRequest(request)
                .then((response) => {
                    this.response(request, response, resolve);
                });
        });
    }

    private response(request: any, response: any, resolve: Function) {
        this.log("Incoming: ", response);

        const gameplay = Gamestate.getCurrentGame();

        const builtRecords = BuilderManager.buildRecord(gameplay, request, response);

        try {
            if (builtRecords) {
                for (const builtRecord of builtRecords) {
                    gameplay.addRecord(builtRecord);
                }
            }
            resolve(response);
        } catch (e) {
            Logger.error(e);
        }
    }

    /**
     * Log a message with colored label
     *
     * @param message {string}
     */
    private log(message: string, obj: any) {
        Logger.info("%c Comms Manager ", "background: #3f3; color: #fff", message, obj);
    }
}

export default new CommsManager();
